import React from 'react'
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import logo from "../../images/logo.png";
import "./searchnav.scss";

import AuthButton from "../Auth/AuthButton.js"; 

const SearchNav = () => {
  return (
    <div>
        <nav className="navbar navbar-expand-lg"> {/* 20240322 jag navbar-light bg-light">*/}
        <div className="container-fluid">
          <a className="navbar-brand" href="/search">
            <img src={logo} alt="logo" height="45" width="125" />
            {/* 20240322 jag<span className="harlequin">Harlequin</span>*/}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="true"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/models"
                >
                  Models
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/nodes" className="nav-link">
                  Nodes
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/search" className="nav-link">
                  Search
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/scan" className="nav-link">
                  Scan
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/shop" className="nav-link">
                  Shop
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/health" className="nav-link">
                  Health
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/document" className="nav-link">
                  Document
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  About
                </Link>
              </li>              
            </ul>
            <span className="navbar-text">
              <AuthButton/>
            </span>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default SearchNav